export enum CONFIGCAT_FLAGS {
	FIELD_END_OF_INSPECTION = 'IsolveFieldEndOfInspection',
	DISABLE_DECISION_TAB_FOR_ITAU = 'isolveDisableDecisionTabForItau',
	BUTTON_CREATE_PRE_ANALYSIS = 'buttonCreatepreanalysis',
	DISABLE_PHONE_UPDATE_MODAL = 'isIsolvePhoneUpdateModalDisabled',
	NOVOS_COMPRADORES_INTERNAL_CORBAN_PRIORITIES = 'isolveNovosCompradoresInternalCorbanPriorities',
	NOVOS_COMPRADORES_SORT_BY_BACKEND_PRIORITY = 'isolveNovosCompradoresSortByBackendPriority',
	ENABLE_NEW_AUTH_FLOW = 'isNewAuthFlowEnabled',
	IS_OPA_ENABLED = 'isOpaEnabled',
	ENABLE_PAGINATED_PROPOSAL_OBSERVATIONS = 'isolveEnableV2ProposalObservationsGetter',
	HIDE_ARCHIVE_BUTTON_FOR_MMS_SOURCE = 'isolveHideArchiveButtonForMmsSource',
	MAGIC_LINK_EDITION = 'isolveMagicLinkEdition'
}
